import {WidgetType} from '@codemirror/view'
import type {Element} from 'hast'

/**
 * Generic widget that renders as the specified void (childless) HTML element.
 */
export class VoidElementWidget extends WidgetType {
  #node: Element
  #className: string | undefined

  /**
   * @param node hast node to render as a void element. Any `children` will be ignored.
   * @param className Optional class name to apply in addition to `node.properties.class`.
   */
  constructor(node: Element, className?: string) {
    super()
    this.#node = node
    this.#className = className
  }

  override toDOM() {
    // We could use hast-util-to-dom to handle the element creation for us, but it's probably not worth the added dependency
    const element = document.createElement(this.#node.tagName)
    for (const [key, value] of Object.entries(this.#node.properties)) element.setAttribute(key, String(value))
    if (this.#className) element.classList.add(this.#className)
    return element
  }

  override eq(widget: WidgetType): boolean {
    return widget instanceof VoidElementWidget && widget.#node === this.#node && widget.#className === this.#className
  }
}
